import React, { useEffect, useRef, useState } from "react";
import client from "@/lib/api";
import { fmtPrice } from "@/lib/format";

export function MarketPulse() {
  const [rows, setRows] = useState([]);
  const prev = useRef({});
  const [flash, setFlash] = useState({});

  const load = async () => {
    try {
      const { data } = await client.get("/market/pulse");
      const f = {};
      data.forEach((r) => {
        const p = prev.current[r.symbol];
        if (p != null && p !== r.price) f[r.symbol] = r.price > p ? "up" : "down";
        prev.current[r.symbol] = r.price;
      });
      setRows(data);
      if (Object.keys(f).length) {
        setFlash(f);
        setTimeout(() => setFlash({}), 900);
      }
    } catch (e) {
      /* keep last */
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    return () => clearInterval(id);
  }, []);

  if (!rows.length) return null;
  const items = [...rows, ...rows];

  return (
    <div data-testid="market-pulse" className="border-y border-white/10 bg-[#070707] overflow-hidden flex items-stretch">
      <div className="shrink-0 flex items-center gap-1.5 px-4 border-r border-white/10 bg-[#0a0a0a]">
        <span className="live-dot w-1.5 h-1.5 rounded-full bg-[#ccff00]" />
        <span className="font-mono-cl text-[10px] tracking-[0.16em] text-[#ccff00] uppercase">Live</span>
      </div>
      <div className="overflow-hidden flex-1">
        <div className="animate-marquee py-2.5">
          {items.map((r, i) => {
            const up = r.change >= 0;
            const fl = flash[r.symbol];
            return (
              <span
                key={i}
                className="inline-flex items-center gap-2 px-6 border-r border-white/5 transition-colors duration-500"
                style={{ backgroundColor: fl === "up" ? "rgba(204,255,0,0.10)" : fl === "down" ? "rgba(239,68,68,0.10)" : "transparent" }}
              >
                <span className="font-mono-cl text-xs font-bold text-white">{r.symbol}</span>
                {r.asset_type === "stock" && (
                  <span className="font-mono-cl text-[9px] font-bold tracking-[0.12em] text-black bg-[#ccff00] rounded px-1 py-px leading-none">US</span>
                )}
                <span className="font-mono-cl text-xs text-zinc-400">${fmtPrice(r.price)}</span>
                <span className={`font-mono-cl text-xs font-semibold ${up ? "text-[#ccff00]" : "text-red-400"}`}>
                  {up ? "▲" : "▼"} {Math.abs(r.change).toFixed(2)}%
                </span>
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}
